module.exports = __webpack_public_path__ + "static/img/3-info-b5.8457c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b5.jpg
// module id = Mf4/
// module chunks = 0